import { Injectable } from '@angular/core';
import { CompteEntreprise, Contact, Invitation, CompanyMscompany, CompanyDetails } from '../models/compteEntreprise.model';
import { HttpClient } from '@angular/common/http';
import { AccessData } from '../models/accessData.model';
import { DetailsEntreprise } from '../models/detailsEntreprise.model';
import { environment } from "environments/environment";
import { lastValueFrom } from 'rxjs';
import { GS1NotificationService } from '@gs1france/gs1-components-library';
import { TranslateService } from '@ngx-translate/core';
import { AccessDataByEmailInputModel } from '../models/accessDataByEmailInput.model';
 let __URL_API__  = `${environment.URL_API}`; 


@Injectable({providedIn: 'root'})
export class CompteEntrepriseService {

    constructor(private _http: HttpClient, private notificationService: GS1NotificationService, private translate: TranslateService) { }


    async getCompteEntreprise(): Promise<CompteEntreprise> {
        try {
            let response = await this._http.get(__URL_API__ + 'api/Entreprise/GetCompteByNum')
                .toPromise();
            return response as CompteEntreprise;
        } catch (error) {
            return await this.handleError(error);
        }
    }

    async getMSCompanyEntreprise(accountNumber: string): Promise<CompanyMscompany> {
        try {
            let response = await lastValueFrom(this._http.get(__URL_API__ + 'api/Entreprise/GetMsCompanyEntreprise?accountNumber=' + accountNumber));
            return response as CompanyMscompany;
        } catch (error) {
            return await this.handleError(error);
        }
    }

    async getDtailsEntreprise(siren: string): Promise<DetailsEntreprise[]> {
        try {
            let response = await lastValueFrom(this._http.get(__URL_API__ + 'api/Entreprise/GetDetailEntreprise?siren=' + siren));
            return response as DetailsEntreprise[];
        } catch (error) {
            return await this.handleError(error);
        }
    }

    async getAccessDataByEmail(accessData: AccessDataByEmailInputModel): Promise<AccessData> {
        try {
            let response = await lastValueFrom(this._http.post(__URL_API__ + 'api/companies/GetAccessDataByEmail',accessData));
            return response as AccessData;
        } catch (error: any) {
            return await this.handleError(error);
        }
    }

    async getCompanyDetails (): Promise<CompanyDetails> {
        /* try {
            let response: CompanyDetails = await lastValueFrom(this._http.get<CompanyDetails>(__URL_API__ + 'api/companies'));
            return response;
        } catch (err) {
            return await this.handleError(err);
        } */
        return new CompanyDetails();
    }

    async updateCompteEntreprise(compteEntrepriseForm: CompteEntreprise): Promise<string> {
        let formData: FormData = new FormData();
        formData.append('nom', compteEntrepriseForm.nom == undefined ? "" : compteEntrepriseForm.nom.toString());
        formData.append('adresse', compteEntrepriseForm.adresse == undefined ? "" : compteEntrepriseForm.adresse.toString());
        formData.append('adresseComp', compteEntrepriseForm.adresseComp == undefined ? "" : compteEntrepriseForm.adresseComp.toString());
        formData.append('codePostale', compteEntrepriseForm.codePostale == undefined ? "" : compteEntrepriseForm.codePostale.toString());
        formData.append('ville', compteEntrepriseForm.ville == undefined ? "" : compteEntrepriseForm.ville.toString());
        formData.append('pays', compteEntrepriseForm.pays == undefined ? "" : compteEntrepriseForm.pays.toString());
        formData.append('telephone', compteEntrepriseForm.telephone == undefined ? "" : compteEntrepriseForm.telephone.toString());
        formData.append('siren', compteEntrepriseForm.siren == undefined ? "" : compteEntrepriseForm.siren.toString());

        try {
            let response = await lastValueFrom(this._http.put(__URL_API__ + 'api/Entreprise/Update', formData));
            return response as string;
        } catch (error) {
            return await this.handleError(error);
        }
    }

    async updateMscompany(company: CompanyMscompany): Promise<void> {
        try {
            await lastValueFrom(this._http.patch(__URL_API__ + 'api/Entreprise/UpdateMsCompany', company));
        } catch (error) {
            return await this.handleError(error);
        }
    }

    async updateCompanyDetails(company: CompanyDetails): Promise<CompanyDetails> {
        try {
            const newCompany = await lastValueFrom(this._http.patch<CompanyDetails>(__URL_API__ + 'api/companies', company, {headers: {'Content-Type':  'application/json'}}));
            this.notificationService.addNotification(this.translate.instant('Company.Activity.updateSuccess'), 'success');
            return newCompany;
        } catch (err) {
            return await this.handleError(err, 'Company.Activity.updateError');
        }
    }

    async retrieveContacts(): Promise<Contact[]> {
        try {
            let response = await lastValueFrom(this._http.get(__URL_API__ + 'api/Entreprise/ListeContacts'));
            return response as Contact[];
        } catch (error) {
            return await this.handleError(error);
        }
    }

    async retrieveInvitations(): Promise<Invitation[]> {
        try {
            let response = await lastValueFrom(this._http.get(__URL_API__ + 'api/Entreprise/ListeInvitations'));
            return response as Invitation[];
        } catch (error) {
            return await this.handleError(error);
        }
    }

    async getUsers(): Promise<{count: number, invitations: Invitation[]}> {
        try {
            let response = await lastValueFrom(this._http.get<{count: number, invitations: Invitation[]}>(__URL_API__ + 'api/User'));
            return response;
        } catch (error) {
            return await this.handleError(error, 'Users.load-error');
        }
    }

    async getSpecialUsers(): Promise<{count: number, invitations: Invitation[]}> {
        try {
            let response = await lastValueFrom(this._http.get<{count: number, invitations: Invitation[]}>(__URL_API__ + 'api/User?isMain=true&isBilling=true'));
            return response;
        } catch (error) {
            return await this.handleError(error, 'Users.load-error');
        }
    }

    async deleteUser(id: string,idContact:string, name: string): Promise<any> {
        try {
            let response = await lastValueFrom(this._http.patch<{count: number, invitations: Invitation[]}>(__URL_API__ + 'api/User/delete?idInvit =' + id+'&idContact='+idContact, null));
            this.notificationService.addNotification(this.translate.instant('Users.Delete.success', {name}), 'success', 15000);
            return idContact;
        } catch (error) {
            return await this.handleError(error, 'Users.load-error');
        }
    }





    private handleError(error: any, message?: string): Promise<any> {
        if (message) {
            this.notificationService.addNotification(this.translate.instant(message), 'error');
        }
        return Promise.reject(error.message || error);
    }
}